import React from 'react'
import ArrowNext from '../../../../assets/ArrowNext'
import { COLORS } from '../../../../styles/colors'
import { TypographyPrimary16Bold } from '../../../../ui/typography/TypographyPrimary16Bold'
import { CalendarHeaderProps } from '../../types'
import { formatMonth, formatYear } from '../../utils/dateFormatters'
import {
	ClickableText,
	HeaderCenter,
	NavigationButton,
	StyledCalendarHeader,
} from './CalendarHeader.styles'

/**
 * Компонент шапки календаря с навигацией
 *
 * Отображает:
 * - Стрелку влево (предыдущий месяц/год)
 * - Название месяца (клик открывает MonthPicker)
 * - Год (клик открывает YearPicker)
 * - Стрелку вправо (следующий месяц/год)
 */
const CalendarHeader: React.FC<CalendarHeaderProps> = ({
	currentDate,
	mode,
	onModeChange,
	onPrevious,
	onNext,
}) => {
	const handleMonthClick = () => {
		onModeChange('months')
	}

	const handleYearClick = () => {
		onModeChange('years')
	}

	return (
		<StyledCalendarHeader>
			<NavigationButton onClick={onPrevious} aria-label='Предыдущий'>
				<ArrowNext
					direction='left'
					color={COLORS.icon}
					width={24}
					height={24}
				/>
			</NavigationButton>

			<HeaderCenter>
				{mode === 'days' && (
					<>
						<TypographyPrimary16Bold>
							<ClickableText onClick={handleMonthClick}>
								{formatMonth(currentDate)}
								<ArrowNext
									direction='down'
									color={COLORS.icon}
									width={16}
									height={16}
								/>
							</ClickableText>
						</TypographyPrimary16Bold>

						<TypographyPrimary16Bold>
							<ClickableText onClick={handleYearClick}>
								{formatYear(currentDate)}
								<ArrowNext
									direction='down'
									color={COLORS.icon}
									width={16}
									height={16}
								/>
							</ClickableText>
						</TypographyPrimary16Bold>
					</>
				)}

				{mode === 'months' && (
					<TypographyPrimary16Bold>
						<ClickableText onClick={handleYearClick}>
							{formatYear(currentDate)}
						</ClickableText>
					</TypographyPrimary16Bold>
				)}

				{mode === 'years' && (
					<TypographyPrimary16Bold>
						{formatYear(currentDate)}
					</TypographyPrimary16Bold>
				)}
			</HeaderCenter>

			<NavigationButton onClick={onNext} aria-label='Следующий'>
				<ArrowNext
					direction='right'
					color={COLORS.icon}
					width={24}
					height={24}
				/>
			</NavigationButton>
		</StyledCalendarHeader>
	)
}

export default CalendarHeader
